export const validateForm = {
  required: 'Это поле необходимо заполнить',
  phone: 'Некорректный формат номера телефона',
  email: 'Неверный формат Email',
  contract: 'Длинна номера контракта должна быть 9 символов',
}
